export default __webpack_public_path__ + "static/media/640_business05-en-web.8150223e.png";